import { Observable } from 'rxjs';
import { createSelectMap } from '@ngxs/store';
import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  BatchTranslatePayload,
  DeleteTranslationsResponse,
  GetTranslationsWithDateResponse,
  LabelValue,
  TranslationsList,
} from '../../../model';
import { ApplicationSelectorState, ConfigState } from '../../state';

@Injectable({
  providedIn: 'root',
})
export class TranslationEditorService {
  private readonly http = inject(HttpClient);

  selectors = createSelectMap({
    baseApiUrl: ConfigState.baseApiUrl,
    application: ApplicationSelectorState.application,
    environment: ApplicationSelectorState.environment,
  });

  getTranslations(application: LabelValue, environment: LabelValue, languages: Array<string>): Observable<TranslationsList> {
    const url = `${this.selectors.baseApiUrl()}/applications/${application.value}/env/${environment.value}/translations`;
    return this.http.post<TranslationsList>(url, languages);
  }

  getTranslationsWithDate(
    application: LabelValue,
    environment: LabelValue,
    languages: Array<string>
  ): Observable<GetTranslationsWithDateResponse> {
    const url = `${this.selectors.baseApiUrl()}/applications/${application.value}/env/${environment.value}/translationsWithDate`;
    return this.http.post<GetTranslationsWithDateResponse>(url, languages);
  }

  deleteTranslations(payload: Array<string>): Observable<DeleteTranslationsResponse> {
    const url = `${this.selectors.baseApiUrl()}/applications/${this.selectors.application()}/env/${this.selectors.environment()}/translations`;
    return this.http.request<DeleteTranslationsResponse>('delete', url, { body: JSON.stringify(payload) });
  }

  batchTranslate(payload: BatchTranslatePayload): Observable<TranslationsList> {
    const url = `${this.selectors.baseApiUrl()}/applications/${this.selectors.application()}/env/${this.selectors.environment()}/batch-translation`;
    return this.http.patch<TranslationsList>(url, payload);
  }
}
